export * from './status.directive';


// WEBPACK FOOTER //
// ./src/app/pages/shared/directives/index.ts